module.exports = __webpack_public_path__ + "img/0Q3B7249_Black.6bdf7402.jpg";